<template>
	<template v-if="frame === 'old'">
		<v-container v-if="$slots.header" fluid>
			<slot name="header" />
		</v-container>
		<router-view />
	</template>
	<v-container v-else-if="frame !== 'old'" fluid>
		<v-row :dense="!noGutters && dense" :no-gutters="noGutters">
			<v-col v-if="$slots.header" cols="12">
				<slot name="header" />
			</v-col>
			<v-col cols="12">
				<router-view />
			</v-col>
		</v-row>
	</v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
	default: { type: String, default: 'old' },
	dense: { type: Boolean, default: true },
	noGutters: { type: Boolean, default: false },
})

const route = useRoute()

const frame = computed(() => {
	const frames = ['old', 'default']
	const value = route.matched
		?.map((match) => match.meta)
		?.filter((meta) => meta)
		?.pop()?.frame

	if (!value) return props.default

	return frames.includes(value) ? value : props.default
})
</script>
